module.exports = {
  COMPANY: "365stream",
  SITE_URL: "https://365.stream",
  VERSION: "2.20.0",
  TRON_FEE_USDT: 1,
  BSC_FEE_USDT: 2,
  RECPATCHA_KEY: "6LeLZCEdAAAAAEMcL0xVv2cNHC-SxEFIQHdDN9XB", //real
  // RECPATCHA_KEY: "6LdiBJgcAAAAAPd2F5DpF4m4ybizas9oXMMvRqG6", //test
  API_URL: "https://api.365.stream",
  // API_URL: "http://localhost:5001",
  // API_URL: "http://localhost:5001",
};
